import { useQuery } from "@tanstack/react-query";

import { api, unwrap } from "./client";

export const CHECKER_KEY = ["checker-account"] as const;

export function useCheckerKinds() {
  return useQuery({
    queryKey: ["checkers"],
    queryFn: () => unwrap(api.GET("/api/checkers")),
    staleTime: Infinity,
  });
}

/** The user's number checker, or null when none is saved. */
export function useCheckerAccount() {
  return useQuery({
    queryKey: CHECKER_KEY,
    queryFn: () => unwrap(api.GET("/api/checker-account")),
  });
}
